import { ChangeEvent, FC, KeyboardEvent } from 'react'
import styled from 'styled-components'

export type InputProps = {
  value: string
  placeholder: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onKeyPress?: (event: KeyboardEvent) => void
}

export const Input: FC<InputProps> = (props) => {
  const { onChange, placeholder, value, onKeyPress } = props
  return <StyledInput value={value} onChange={onChange} placeholder={placeholder} onKeyPress={onKeyPress} />
}

const StyledInput = styled.input<InputProps>`
  border: 1px solid #3e9f26;
  outline: none;
  font-size: 16px;
  padding: 10px;
  transition: 0.2s;
  width: 100%;
  border-radius: 3px;
  color: #333;
`
